import { useEffect } from 'react';
import SiteNavbar from '../../components/feature/SiteNavbar';
import SiteTrustBar from '../../components/feature/SiteTrustBar';
import SiteFooter from '../../components/feature/SiteFooter';
import PageHero from '../../components/feature/PageHero';
import PageAiAnswer from '../../components/feature/PageAiAnswer';
import PageProcess from '../../components/feature/PageProcess';
import PageWhyChoose from '../../components/feature/PageWhyChoose';
import PageAreas from '../../components/feature/PageAreas';
import PageTestimonials from '../../components/feature/PageTestimonials';
import PageFaq from '../../components/feature/PageFaq';
import PageBookingCta from '../../components/feature/PageBookingCta';
import BrandStory from './components/BrandStory';

const aboutFaqs = [
  { q: 'Who is Willie Robinson and what is his background?', a: 'Willie Robinson is the founder of Tec\'s Limo Service and a former Charleston County Police Officer with years of law enforcement and security experience, including work with three presidential campaigns. His background in safety and professionalism guides every aspect of the business.' },
  { q: 'How long has Tec\'s Limo Service been operating?', a: 'Tec\'s Limo Service has been providing professional luxury transportation in Charleston, SC for over a decade. With years of consistent 5-star service, we have become one of the most trusted transportation companies in the region.' },
  { q: 'What makes Tec\'s Limo Service different from other companies?', a: 'Tec\'s Limo Service stands out through our founder\'s law enforcement background, commitment to punctuality, discreet professional service, and genuine care for client safety and comfort. We don\'t just drive — we deliver an experience built on trust and reliability.' },
  { q: 'Are your drivers background-checked and professionally trained?', a: 'Yes. All Tec\'s Limo Service chauffeurs undergo thorough background checks and professional training focused on safety, navigation, customer service, and delivering the luxury experience our clients expect on every single ride.' },
  { q: 'Do you work with corporate accounts and business clients?', a: 'Yes. Tec\'s Limo Service provides executive transportation for businesses, corporate clients, and professionals. We offer discreet, punctual service tailored to the demands of business travel, including airport transfers and meeting logistics.' },
  { q: 'What types of vehicles does Tec\'s Limo Service use?', a: 'We operate clean, luxury vehicles maintained to the highest standards. Our fleet is designed to provide maximum comfort, privacy, and elegance for every client and occasion — from solo executive rides to group wedding transportation.' },
  { q: 'Is Tec\'s Limo Service licensed and fully insured?', a: 'Yes. Tec\'s Limo Service is fully licensed and insured for commercial passenger transportation in South Carolina. Your safety and protection are our absolute priority on every single trip we complete.' },
  { q: 'How do you ensure the driver will always be on time?', a: 'Our chauffeurs arrive early — not just on time. We account for traffic patterns, adjust for flight changes, and plan every pickup with buffer time built in. Our on-time record is 100%, and we intend to keep it that way.' },
];

const aiFeatures = [
  { icon: 'ri-shield-user-fill', title: 'Founded by a Police Officer', desc: 'Willie Robinson brings law enforcement standards and presidential-level security experience to every ride' },
  { icon: 'ri-award-fill', title: 'Premium Fleet', desc: 'Meticulously maintained luxury vehicles cleaned and prepared before every single trip' },
  { icon: 'ri-heart-fill', title: 'Client-First Culture', desc: 'Every decision is made around your comfort, safety, privacy, and satisfaction — no exceptions' },
];

export default function AboutPage() {
  useEffect(() => {
    document.title = 'About TECS Limo Service | Charleston SC Luxury Transportation Company';
  }, []);

  return (
    <main className="min-w-[1024px]">
      <SiteNavbar />
      <PageHero
        badge="Founded by a Former Police Officer"
        headline="A Transportation Company Built on"
        accentLine="Reliability & Service"
        description="Tec's Limo Service was founded on a commitment to professionalism, punctuality, and client safety. Discover the story behind Charleston's most trusted luxury transportation company."
        image="https://public.readdy.ai/ai/img_res/8b23f003425a6ae9e8acb71d953aa946.jpg"
        stats={[
          { value: '10+', label: 'Years Service' },
          { value: '5★', label: 'Google Rated' },
          { value: '24/7', label: 'Available' },
        ]}
      />
      <SiteTrustBar />
      <BrandStory />
      <PageAiAnswer
        label="About Us"
        title="About Tec's Limo Service LLC"
        body="<strong>Tec's Limo Service</strong> is a professional luxury transportation company founded by Willie Robinson — a former Charleston County Police Officer committed to delivering safe, reliable, and discreet transportation services throughout Charleston, SC and the surrounding Lowcountry region."
        bodyExtra="The company prioritizes punctuality, safety, and client satisfaction across all services. With a background in law enforcement and presidential security, Willie Robinson brings a level of professionalism and attention to detail that sets Tec's Limo Service apart from every other transportation option in the Charleston area."
        features={aiFeatures}
      />
      <PageProcess
        headline="Our Commitment to"
        accentLine="Every Client"
      />
      <PageWhyChoose />
      <PageAreas />
      <PageTestimonials />
      <PageFaq faqs={aboutFaqs} headline="Questions About" subheadline="Our Company" />
      <PageBookingCta
        headline="Book with Confidence"
        accentLine="Today"
        description="Experience the Tec's Limo Service difference. Professional, licensed, and trusted luxury transportation — available 24/7 across Charleston and the Lowcountry."
      />
      <SiteFooter />
    </main>
  );
}
